import { PropTypes } from 'prop-types'
import Button from 'components/formElements/Button'
import { useParams } from 'react-router-dom'
import { useState } from 'react'
import { useRequest } from 'hooks/useRequest'
import useToast from 'hooks/useToast'
import Icons from 'assets/icons'
import { useFileReader } from 'hooks/useFileReader'
import DefaultSelect from 'components/formElements/DefaultSelect'
import { documentTypes } from 'utils/Constants'
import { Calendar } from 'primereact/calendar'
import moment from 'moment/moment'

const AddDocumentModalContent = ({ handleClose, handleAdd }) => {
	const { projectId } = useParams()
	const [saveSla, saveDataoading] = useRequest()
	const { showToast } = useToast()
	const [filesData, setFilesData, convert] = useFileReader()
	const [addForm, setAddForm] = useState({
		projectId: projectId,
		documentDate: null
	})
    const [reportType, setReportType] = useState();


	const handleChange = (e) => {
		if (e.name == 'files') {
			convert(e.files)
		} else {
			setAddForm((prev) => ({ ...prev, [e.name]: e.value }))
		}
	}
	const removeFile = (file) => {
		setFilesData((prev) => [...prev.filter((f) => f.fileName != file.fileName)])
	}
	const addFiles = async () => {
		let isOk = false
		for (let index = 0; index < filesData.length; index++) {
			const f = filesData[index]
			const formDatas = new FormData()
			formDatas.append('File', f.file)
			formDatas.append('ProjectId', addForm.projectId)
			formDatas.append('ContinuousReportType', reportType?.value)
			if ([1,2,6].includes(reportType?.value)) {
				formDatas.append('DocumentDate', addForm.documentDate)
			}
			await saveSla('/Project/AddProjectDocuments', {
				method: 'POST',
				data: formDatas,
			}).then((res) => {
				if (res.data.ok) {
					isOk = true
				}
			})
		}
		return isOk
	}
	const handleSubmit = async () => {
		if (filesData.length < 1) {
			showToast('Lütfen Dosya Ekleyiniz.', 'error')
		} else if ([1,2,6].includes(reportType?.value) && !addForm.documentDate){
			showToast('Lütfen Rapor Tarihi Seçiniz.', 'error')
		} else {
			const isOk = await addFiles()
			if (isOk) {
				showToast('Proje Dökümanı Eklendi.', 'success')
				handleClose()
				handleAdd()
				setFilesData([])
			}
		}
	}
	return (
		<div className='w-100 d-flex flex-column gap-3 approval-modal-content'>
			<div className='row'>
				<div className='col-md-12'>
					<label className='filterTask-file-upload--form--row--item--file-uploader--label' htmlFor='file-uploader'>
						<span className='filterTask-file-upload--form--row--item--file-uploader--label--text'>Dosya yüklemek için tıklayınız</span>
					</label>
					<input
						type='file'
						name='files'
						multiple
						onChange={(e) => handleChange(e.target)}
						id='file-uploader'
						className='filterTask-file-upload--form--row--item--file-uploader--input'
					/>
				</div>
				<div className='ml-4 w-100 mt-2 gap-3'>
					{filesData?.length > 0 &&
						filesData?.map((file, i) => (
							<div className='text-sm comment-fileList w-unset' key={i}>
								<div className='d-flex align-items-center'>{file?.fileName}</div>
								<Icons.delete
									onClick={() => {
										removeFile(file)
									}}
									size={16}
								/>
							</div>
						))}
				</div>
			</div>
			<div className='row'>
				<div className='form-control col-md-12 -mt-1'>
					{/* <div className='form-control-label'>Rapor Tipi</div> */}
					<DefaultSelect 
						placeholder={"Döküman Tipi"}
						value={reportType}
						selectOptions={documentTypes.map((pt) => ({ label: pt?.type?.toUpperCase(), value: Number(pt.value) }))}
						handleChange={(e) => setReportType(e)}
					/>
				</div>
			</div>
			{ [1,2,6].includes(reportType?.value) && (
				<div className='row'>
					<div className='form-control col-md-12'>
						<Calendar
							dateFormat='dd/mm/yy'
							placeholder='Rapor Tarihi'
							name='documentDate'
							onChange={(e) => {
								handleChange({ name: e.target.name, value: moment(e.target.value).add(3, 'hours').toISOString() })
							}}
						/>
					</div>
				</div>
			)}
			
			<div className='row justify-content-center'>
				<div className='col-md-6'>
					<Button
						handleClick={handleSubmit}
						loading={saveDataoading}
						disabled={saveDataoading}
						className='btn-success w-100 justify-content-center'
						title={'Ekle'}
					/>
				</div>
				<div className='col-md-6'>
					<Button handleClick={handleClose} className='btn-danger-outline w-100 justify-content-center' title={'Vazgeç'} />
				</div>
			</div>
		</div>
	)
}
AddDocumentModalContent.propTypes = {
	handleClose: PropTypes.func,
	handleAdd: PropTypes.func,
}
export default AddDocumentModalContent
